import { render, staticRenderFns } from "./ResultItem.vue?vue&type=template&id=fe3c797c&scoped=true&lang=pug&"
import script from "./ResultItem.vue?vue&type=script&lang=ts&"
export * from "./ResultItem.vue?vue&type=script&lang=ts&"
import style0 from "./ResultItem.vue?vue&type=style&index=0&id=fe3c797c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3c797c",
  null
  
)

export default component.exports